module.exports = __webpack_public_path__ + "img/live-drop-82be34cbbe6f0e338cab89c759aa0660.4e542c7e.png";